import {AfterViewInit, ChangeDetectionStrategy, Component, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {FlowMeterRequest} from '../flow-meter-request';
import {Tractor, FlowMeterDataLoader, FlowMeterData, FlowMeterBatchDataLoader, notify} from 'shared';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import {TractorService} from '../../../stores/tractor.service';
import {GoldenLayoutContainer} from 'ngx-golden-layout';
import GoldenLayout from 'golden-layout';
import {DxiButtonComponent} from 'devextreme-angular/ui/nested';


@Component({
  selector: 'app-flow-meter-report-page',
  templateUrl: './flow-meter-report-page.component.html',
  styleUrls: ['./flow-meter-report-page.component.scss'],
})
export class FlowMeterReportPageComponent implements OnInit, AfterViewInit {

  request: FlowMeterRequest = new FlowMeterRequest();
  tractor?: Tractor;
  toolbarLoadingVisible = true;
  tractors: DataSource;
  isFlowMeterDataLoading: boolean;
  flowMeterData: FlowMeterData;
  flowMeterDataLoader: FlowMeterDataLoader = new FlowMeterDataLoader();
  flowMeterBatchDataLoader: FlowMeterBatchDataLoader = new FlowMeterBatchDataLoader();

  width: number;
  height: number;
  isDrawerOpen: boolean;
  selectedItemKeys = [];
  searchBtnClick;
  searchBtnOptions;

  @ViewChild('btn', {static: false})
  searchBtn: DxiButtonComponent;

  selectedItems: {key: string, items: Tractor[]}[] = [];

  constructor(
    private tractorService: TractorService,
    @Inject(GoldenLayoutContainer) private container: GoldenLayout.Container,
  ) {
    this.searchBtnOptions = {
      stylingMode: 'text',
      icon: 'ld-fuel-station',
    };
  }

  tractorsCount(list): number {
    return (list ?? this.tractors.items()).reduce((sum, curr) => sum + curr.items.length, 0);
  }

  ngOnInit(): void {
    this.width = this.container.getElement().width();
    this.height = this.container.getElement().height() - 50;
  }

  ngAfterViewInit(): void {
    this.tractorService.newDataSource({
      paginate: false,
    }).load().then(all => {
      this.setupSearchBtn(all.length);
      // Data source
      this.tractors = new DataSource({
        paginate: false,
        group: [{selector: 'domain_name', desc: true}],
        sort: [{selector: 'domain_name'}, {selector: 'name'}],
        store: new ArrayStore({
          key: 'id',
          data: all.map(item => {
            item.disabled = !(item as Tractor).tracker?.hasFlowMeter();
            return item;
          }),
        }),
      });
      this.toolbarLoadingVisible = false;
      // this.popupLoadingVisible = false;
    });
  }

  setupSearchBtn(count) {
    this.searchBtnOptions.text = 'Tous (' + count + ')';
    this.searchBtnOptions.hint = 'Cliquer pour afficher seulement les débitmètres';
    this.searchBtnOptions.type = 'normal';
    this.searchBtnOptions.onClick = (e) => {
      const type = e.component.option('type');
      if (type === 'normal') {
        this.searchBtnOptions.type = 'default';
        this.searchBtnOptions.text = 'Avec débitmètre';
        this.searchBtnOptions.hint = 'Cliquer pour afficher tous';
        this.tractors.filter(t => (t as Tractor).tracker?.hasFlowMeter());
      } else {
        this.searchBtnOptions.type = 'normal';
        this.searchBtnOptions.text = 'Tous';
        this.searchBtnOptions.hint = 'Cliquer pour afficher seulement les débitmètres';
        this.tractors.filter(null);
      }
      this.tractors.reload().then((all) => {
        this.searchBtnOptions.text += ' (' + this.tractorsCount(all) + ')';
        this.searchBtn.instance.repaint();
      });
    };
  }

  load(request: FlowMeterRequest) {
    this.isDrawerOpen = false;
    if (this.selectedItemKeys.length === 0)  {
      this.isDrawerOpen = true;
      return;
    }
    this.isFlowMeterDataLoading = true;
    this.tractorService.fuelBatch(this.flowMeterBatchDataLoader,
      this.selectedItemKeys,
      request.from,
      request.to,
    ).subscribe((r) => {
      if (r.isLoaded) {
        this.isFlowMeterDataLoading = false;
        if (r.isEmpty()) {
          notify('Pas données dans l\'intervale sélectioné');
          return;
        }
        // this.flowMeterData = r.data;
      }
    });
  }

  export() {

  }

  openDrawer() {
    this.isDrawerOpen = !this.isDrawerOpen;
  }
}
